export const BASEURL =  process.env.BASE_URL;
